export default __webpack_public_path__ + "static/media/004.56f43b2e.jpg";